module.exports = __webpack_public_path__ + "img/skyline.719f882d.png";